import { wrapper, createApiClient, Result, ApiError } from "../base";
import { LaravelPaginatedCollection } from "@/types/collections";
import BexTodoDO = Modules.BookingExperts.Data.BexTodoDO;
import BexLabelDO = Modules.BookingExperts.Data.BexLabelDO;
import SparklineValuesDTO = Modules.BookingExperts.Data.SparklineValuesDTO;
import InvokedActionDO = Modules.BookingExperts.Data.InvokedActionDO;
import PieSegmentsDTO = Modules.BookingExperts.Data.PieSegmentsDTO;
import MostUsedActionDTO = Modules.BookingExperts.Data.MostUsedActionDTO;
import BexPriceListDTO = Modules.BookingExperts.Data.BexPriceListDTO;

const baseClient = createApiClient();

export default class {
	getTodos(params: {
		page: number;
		per_page: number;
		sortBy: { key: string; order: "asc" | "desc" }[];
	}): Promise<Result<LaravelPaginatedCollection<BexTodoDO>, ApiError>> {
		return wrapper(baseClient.get("bex/todos", { params }));
	}
	createTodo(bexToDo: BexTodoDO): Promise<Result<BexTodoDO, ApiError>> {
		return wrapper(baseClient.post(`bex/todos`, bexToDo));
	}
	updateTodo(bexToDo: BexTodoDO): Promise<Result<BexTodoDO, ApiError>> {
		return wrapper(baseClient.put(`bex/todos/${bexToDo.uuid}`, bexToDo));
	}
	removeTodo(bexToDo: BexTodoDO): Promise<Result<BexTodoDO, ApiError>> {
		return wrapper(baseClient.delete(`bex/todos/${bexToDo.uuid}`));
	}
	showTodo(uuid: string): Promise<Result<BexTodoDO, ApiError>> {
		return wrapper(baseClient.get(`bex/todos/${uuid}`));
	}
	getTaskLists(id: number): Promise<Result<BexPriceListDTO[], ApiError>> {
		return wrapper(baseClient.get(`bex/todos/task-lists/${id}`));
	}
	getLabels(params: {
		page: number;
		per_page: number;
		sortBy: { key: string; order: "asc" | "desc" }[];
	}): Promise<Result<LaravelPaginatedCollection<BexLabelDO>, ApiError>> {
		return wrapper(baseClient.get("bex/labels", { params }));
	}
	createLabel(bexLabel: BexLabelDO): Promise<Result<BexLabelDO, ApiError>> {
		return wrapper(baseClient.post(`bex/labels`, bexLabel));
	}
	updateLabel(bexLabel: BexLabelDO): Promise<Result<BexLabelDO, ApiError>> {
		return wrapper(baseClient.put(`bex/labels/${bexLabel.uuid}`, bexLabel));
	}
	removeLabel(bexLabel: BexLabelDO): Promise<Result<BexTodoDO, ApiError>> {
		return wrapper(baseClient.delete(`bex/labels/${bexLabel.uuid}`));
	}
	getSparklineValues(
		scope: "label" | "task",
		params?: { daysToLookBack: number }
	): Promise<Result<SparklineValuesDTO, ApiError>> {
		return wrapper(
			baseClient.get(`bex/dashboard/sparkline-values/${scope}`, { params })
		);
	}
	getMostUsed(
		scope: "label" | "task"
	): Promise<Result<MostUsedActionDTO[], ApiError>> {
		return wrapper(baseClient.get(`bex/dashboard/most-used/${scope}`));
	}
	getInvokedActions(params: {
		page: number;
		per_page: number;
		sortBy: { key: string; order: "asc" | "desc" }[];
	}): Promise<Result<LaravelPaginatedCollection<InvokedActionDO>, ApiError>> {
		return wrapper(baseClient.get("bex/dashboard/invoked-actions", { params }));
	}
	getCustomerType(
		periodSelection: "12m" | "24m"
	): Promise<Result<PieSegmentsDTO[], ApiError>> {
		return wrapper(
			baseClient.get(`bex/dashboard/customer-type/${periodSelection}`)
		);
	}
	getCustomerFrequency(
		periodSelection: "12m" | "24m"
	): Promise<Result<PieSegmentsDTO[], ApiError>> {
		return wrapper(
			baseClient.get(`bex/dashboard/customer-frequency/${periodSelection}`)
		);
	}
}
